<div class="menu-content">
  <div id="menu-icon" class="menu-icon menu-icon-arrow" (click)="showNavbar()">
    <span></span>
    <svg x="0" y="0" width="54px" height="54px" viewbox="0 0 54 54">
      <circle cx="25" cy="25" r="16"></circle>
    </svg>
  </div>

  <div>
    <nav id="sidebar" [className]="showNav ? 'menu-collapse' : 'menu-expand'">
      <ul class="custom-navbar">
        <li *ngFor="let item of menuItems" [className]="'item.children.length > 0' ? 'hasSubMenu': '' "
          routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
          <a [routerLink]="item.url_path" title='{{ item.feature_name}}' *ngIf="item.url_path !== '/'">
            <img src="assets/images/{{item.icon}}" alt="" class="menu_image">
            <span style="padding-left:15px">{{ item.feature_name }}</span>
            <i *ngIf="!showNav && item.children && item.children.length > 0" aria-hidden="true"
              class="arrow fa fa-caret-right"></i>
          </a>
          <a href="javascript:void(0);" title='{{ item.feature_name}}' *ngIf="item.url_path === '/'">
            <img src="assets/images/{{item.icon}}" alt="" class="menu_image">
            <span style="padding-left:15px">{{ item.feature_name }}</span>
            <i *ngIf="!showNav && item.children && item.children.length > 0" aria-hidden="true"
              class="arrow fa fa-caret-right"></i>
          </a>
          <ul class="level1" *ngIf="item.children && item.children.length > 0">
            <li routerLinkActive="active" *ngFor="let submenu of item.children"
              [className]="'submenu.children.length > 0' ? 'hasSubMenu': '' ">
              <span>
                <a [routerLink]="submenu.url_path" *ngIf="submenu.url_path !== '/'"
                  title='{{ submenu.Menu_Name }}'>{{ submenu.feature_name  }} </a>
                <a href="javascript:void(0);" *ngIf="submenu.url_path === '/'"
                  title='{{ submenu.Menu_Name }}'>{{ submenu.feature_name  }} </a>
                <i *ngIf="submenu.children && submenu.children.length > 0" aria-hidden="true"
                  class="fa fa-caret-right"></i>
              </span>
              <ul class="level2" *ngIf="submenu.children && submenu.children.length > 0">
                <li routerLinkActive="active" *ngFor="let nextsubmenu of submenu.children">
                  <span>
                    <a [routerLink]="nextsubmenu.url_path">{{nextsubmenu.feature_name}}</a>
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</div>